import { render, staticRenderFns } from "./VerifiedReview.vue?vue&type=template&id=00295cfc&scoped=true"
import script from "./VerifiedReview.vue?vue&type=script&lang=js"
export * from "./VerifiedReview.vue?vue&type=script&lang=js"
import style0 from "./VerifiedReview.vue?vue&type=style&index=0&id=00295cfc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00295cfc",
  null
  
)

export default component.exports